import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/DataTableContainer"
import DashboardLoader from "components/Loader/DashboardLoader"
import DeleteModal from "pages/Calendar/DeleteModal"
import AddLeadModal from "components/Modals/AddLeadModal"
import React, { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "sonner"
import { useUserRegisterMutation } from "store/features/auth/authManagementApi"
import { useCreateClientMutation } from "store/features/client/clientManagementApi"
import {
  useDeleteClientLeadMutation,
  useGetAllClientLeadsQuery,
  useUpdateClientLeadMutation,
} from "store/features/clientLeads/clientLeadsManagement"
import { format, parseISO } from "date-fns"
import hashPassword from "utils/hashPassword"
import { useSelector } from "react-redux"
import { selectUser } from "store/features/auth/authSlice"

const AllLeads = () => {
  const user = useSelector(selectUser)

  // Fetch all client leads
  const { data: clientLeads, isLoading, refetch } = useGetAllClientLeadsQuery("")
  // Delete client lead
  const [makeDeleteLead, { isLoading: deletingLead }] =
    useDeleteClientLeadMutation()
  // State to manage selected lead ID for deletion
  const [selectedLeadId, setSelectedLeadId] = useState(null)
  const [addLeadModal, setAddLeadModal] = useState(false)
  // Create user mutation
  const [createUser, { isLoading: creatingUser }] = useUserRegisterMutation()
  // Create client mutation
  const [makeClient, { isLoading: makingClient }] = useCreateClientMutation()
  // Update client lead mutation
  // const [updateClient, { isLoading: updatingClient }] =
  // useUpdateClientLeadMutation()

  const [updateClientLead, { isLoading: updatingClient }] =
    useUpdateClientLeadMutation()

  // State to manage delete modal visibility
  const [deleteModal, setDeleteModal] = useState(false)
  // Show delete modal
  const showDeleteModal = id => {
    setSelectedLeadId(id)
    setDeleteModal(true)
  }
  // Handle delete event
  const handleDeleteEvent = () => {
    makeDeleteLead(selectedLeadId)
    setDeleteModal(false)
  }

  // Get priority badge
  const getPriorityBadge = priority => {
    const priorityConfig = {
      1: { color: "danger", text: "High" },
      2: { color: "warning", text: "Medium" },
      3: { color: "success", text: "Low" },
      "": { color: "info gradient", text: "Not Set" },
    }
    const config = priorityConfig[priority] || priorityConfig[""]
    return `<span class="badge bg-${config.color}">${config.text}</span>`
  }

  const getStatusBadge = status => {
    const statusConfig = {
      Pending: "warning",
      "In Progress": "primary",
      Completed: "success",
      "On Hold": "danger",
    }
    const color = statusConfig[status] || "secondary"
    return `<span class="badge bg-${color}">${status}</span>`
  }
  //make client
  const handleMakeClient = async lead => {
    const user = {
      role: "client",
      client_email: lead.email,
      client_name: lead.name,

      // password_hash: await hashPassword("qwikITC123456"),

      company_name: lead.company,
      contact_person: "",
      contact_number: lead.phone,
      address: "",
      notes: "",
      company_website: null,
    }
    // Create user
    // const createdUser = await createUser(user).unwrap()
    const createdUser = await makeClient(user)

    console.log("createdUsercreatedUser", createdUser?.data)

    const updatedData = {
      mark_client: true,
    }

    const formData = new FormData()
    formData.append("mark_client", true)

    if (createdUser?.data?.id) {
      await updateClientLead({ id: lead?.id, formData })

      toast.success("Marked as Client Complete")
    } else {
      toast.error("Failed to Marked as Client")
    }
  }

  const [statusFilter, setStatusFilter] = useState("")
  const [priorityFilter, setPriorityFilter] = useState("")

  const [dateFilter, setDateFilter] = useState("")
  const [followUpDateFilter, setFollowUpDateFilter] = useState("")

  // Filter projects based on selected filters
  const filteredProjects = useMemo(() => {
    if (!clientLeads) return []

    return clientLeads.filter(project => {
      const statusMatch = !statusFilter || project.status === statusFilter
      const priorityMatch =
        !priorityFilter || project.priority_status === priorityFilter

      // Date filter logic
      let dateMatch = true
      if (dateFilter && project.start_date) {
        const projectDate = new Date(project.start_date)
          .toISOString()
          .split("T")[0]
        dateMatch = projectDate === dateFilter
      }

      // followUpDate filter logic
      // let followUpDateMatch = true
      // if (followUpDateFilter && project.follow_up_date) {
      //   const projectDate = new Date(project.follow_up_date)
      //     .toISOString()
      //     .split("T")[0]
      //   followUpDateMatch = projectDate === followUpDateFilter
      // }

      let followUpDateMatch = true

      if (followUpDateFilter) {
        // Only include if project has a follow_up_date and matches the selected date
        if (project.follow_up_date) {
          const projectDate = new Date(
            project.follow_up_date
          ).toLocaleDateString("en-CA") // safer for timezone
          followUpDateMatch = projectDate === followUpDateFilter
        } else {
          // Exclude projects with no follow_up_date
          followUpDateMatch = false
        }
      }

      return statusMatch && priorityMatch && dateMatch && followUpDateMatch
    })
  }, [
    clientLeads,
    statusFilter,
    priorityFilter,
    dateFilter,
    followUpDateFilter,
  ])




  // Define table columns
  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Company",
        accessorKey: "company",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Email",
      //   accessorKey: "email",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },

      {
        header: "Phone",
        accessorKey: "phone",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Service Name",
      //   accessorKey: "service_name",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: "Start Date",
      //   accessorKey: "start_date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => {
      //     const date = row.original.start_date
      //     return date ? new Date(date).toISOString().split("T")[0] : "Not set"
      //   },
      // },
      // {
      //   header: "Follow Up Date",
      //   accessorKey: "follow_up_date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => {
      //     const date = row.original.follow_up_date
      //     return date ? new Date(date).toISOString().split("T")[0] : "Not set"
      //   },
      // },
      // {
      //   header: "Follow Up Date",
      //   accessorKey: "follow_up_date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => {
      //     const date = row.original.follow_up_date
      //     const time = row.original.follow_up_time

      //     console.log("Follow up time value:", time) // Debug log
      //     console.log("Follow up time type:", typeof time) // Debug log

      //     if (!date) {
      //       return "Not set"
      //     }

      //     const formattedDate = new Date(date).toISOString().split("T")[0]

      //     let formattedTime = "No time set"
      //     if (time) {
      //       try {
      //         formattedTime = format(parseISO(time), "hh:mm a")
      //       } catch (error) {
      //         console.log("Time formatting error:", error) // Debug log
      //         formattedTime = "Invalid time"
      //       }
      //     }

      //     return (
      //       <div className="text-start">
      //         <div className="fw-medium">{formattedDate}</div>
      //         <div className="text-muted small">{formattedTime}</div>
      //       </div>
      //     )
      //   },
      // },
      // {
      //   header: "End Date",
      //   accessorKey: "end_date",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => {
      //     const date = row.original.end_date
      //     return date ? new Date(date).toISOString().split("T")[0] : "Not set"
      //   },
      // },
      {
        header: "Priority",
        accessorKey: "priority_status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div
            dangerouslySetInnerHTML={{
              __html: getPriorityBadge(row.original.priority_status),
            }}
          />
        ),
      },
      // {
      //   header: "Status",
      //   accessorKey: "status",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      // },
      // {
      //   header: "Status",
      //   accessorKey: "status",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => (
      //     <div
      //       dangerouslySetInnerHTML={{
      //         __html: getStatusBadge(row.original.status),
      //       }}
      //     />
      //   ),
      // },
      {
        header: "Action", //add view, edit, delete actions

        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          return (
            <div className="d-flex  align-items-center gap-1">
              {row.original.mark_client ? (
                <button className="btn btn-success btn-sm " disabled>
                  <i className="fas fa-user-check"></i> Existing Client
                </button>
              ) : (
                <button
                  onClick={() => handleMakeClient(row.original)}
                  className="btn btn-success btn-sm "
                >
                  <i className="fas fa-user-check"></i>{" "}
                  {/* {creatingUser || makingClient || updatingClient
                    ? "Processing..."
                    : "Mark as Client"} */}
                </button>
              )}
              <Link
                to={`/leads/${row.original.id}`}
                className="btn btn-info btn-sm "
              >
                <i className="fas fa-eye"></i>
              </Link>

              {(user?.role == "super_admin" || user?.role == "admin") && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => showDeleteModal(row.original.id)}
                >
                  <i className="fas fa-trash"></i>
                  {/* {deletingLead ? "Deleting..." : "Delete"} */}
                </button>
              )}
            </div>
          )
        },
      },
    ],
    [makingClient, updatingClient, creatingUser, deletingLead]
  )
  const handleExportPDF = () => {
    if (!filteredProjects || filteredProjects.length === 0) {
      toast.warning("No leads available to export PDF");
      return;
    }

    const priorityMap = { 1: "High", 2: "Medium", 3: "Low" };

    const filterTextList = [];
    if (statusFilter) filterTextList.push(`Status: ${statusFilter}`);
    if (priorityFilter) filterTextList.push(`Priority: ${priorityMap[priorityFilter] || priorityFilter}`);
    if (dateFilter) filterTextList.push(`Date: ${dateFilter}`);
    if (followUpDateFilter) filterTextList.push(`Follow-up Date: ${followUpDateFilter}`);
    const activeFilters = filterTextList.length > 0 ? filterTextList.join(" | ") : "All Leads (No Filters)";

    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      toast.error("Please allow popups to download/print PDF");
      return;
    }

    const rowsHtml = filteredProjects
      .map((lead, idx) => {
        const priorityText = priorityMap[lead.priority_status] || "Not Set";
        const startDateText = lead.start_date ? new Date(lead.start_date).toISOString().split("T")[0] : "-";
        const followUpText = lead.follow_up_date ? new Date(lead.follow_up_date).toISOString().split("T")[0] : "-";

        return `
          <tr>
            <td style="text-align: center;">${idx + 1}</td>
            <td style="font-weight: 600;">${lead.name || "-"}</td>
            <td>${lead.company || "-"}</td>
            <td>${lead.phone || "-"}</td>
            <td>${lead.email || "-"}</td>
            <td style="text-align: center;">
              <span class="badge badge-${priorityText.toLowerCase()}">${priorityText}</span>
            </td>
            <td style="text-align: center;">${lead.status || "Pending"}</td>
            <td style="text-align: center;">${startDateText}</td>
            <td style="text-align: center;">${followUpText}</td>
          </tr>
        `;
      })
      .join("");

    const htmlContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Filtered Leads Report - Softzen IT</title>
          <style>
            @page { size: A4 landscape; margin: 10mm; }
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; color: #333; margin: 0; padding: 20px; background: #fff; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2a3042; padding-bottom: 12px; margin-bottom: 15px; }
            .logo { font-size: 24px; font-weight: bold; color: #556ee6; }
            .title { font-size: 18px; font-weight: bold; color: #2a3042; text-align: right; }
            .meta { margin-bottom: 15px; font-size: 12px; color: #666; background: #f8f9fa; padding: 10px 15px; border-radius: 6px; border: 1px solid #e9ecef; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 12px; }
            th { background-color: #2a3042; color: #ffffff; text-align: left; padding: 8px 10px; font-weight: 600; text-transform: uppercase; font-size: 11px; }
            td { padding: 8px 10px; border-bottom: 1px solid #e9ecef; color: #495057; }
            tr:nth-child(even) { background-color: #f8f9fa; }
            .badge { display: inline-block; padding: 3px 8px; border-radius: 4px; font-size: 11px; font-weight: 600; }
            .badge-high { background-color: #f8d7da; color: #721c24; }
            .badge-medium { background-color: #fff3cd; color: #856404; }
            .badge-low { background-color: #d4edda; color: #155724; }
            .badge-not { background-color: #e2e3e5; color: #383d41; }
            .footer { margin-top: 20px; text-align: right; font-size: 11px; color: #74788d; border-top: 1px solid #e9ecef; padding-top: 10px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo">Softzen IT</div>
            <div class="title">Client Leads Report</div>
          </div>
          <div class="meta">
            <div><strong>Applied Filters:</strong> ${activeFilters}</div>
            <div><strong>Total Leads Exported:</strong> ${filteredProjects.length} | <strong>Generated On:</strong> ${new Date().toLocaleString()}</div>
          </div>
          <table>
            <thead>
              <tr>
                <th style="width: 40px; text-align: center;">SL</th>
                <th>Lead Name</th>
                <th>Company</th>
                <th>Phone</th>
                <th>Email</th>
                <th style="text-align: center;">Priority</th>
                <th style="text-align: center;">Status</th>
                <th style="text-align: center;">Start Date</th>
                <th style="text-align: center;">Follow Up</th>
              </tr>
            </thead>
            <tbody>
              ${rowsHtml}
            </tbody>
          </table>
          <div class="footer">
            Report generated by Softzen IT Management System
          </div>
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  // Show loader while fetching data
  if (isLoading) {
    return <DashboardLoader />
  }
  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">

          {/* Breadcrumb Section */}
          <div>
            <Breadcrumb title="Tables" breadcrumbItem="Leads" />
          </div>

          {/* Action Buttons */}
          <div className="d-flex flex-wrap gap-2">

            <button
              type="button"
              onClick={handleExportPDF}
              className="btn btn-danger d-flex align-items-center px-3"
              title="Download PDF of filtered leads"
            >
              <i className="fas fa-file-pdf me-2"></i>
              Export PDF ({filteredProjects?.length || 0})
            </button>

            <button
              type="button"
              onClick={() => setAddLeadModal(true)}
              className="btn btn-primary d-flex align-items-center px-3"
            >
              <i className="fas fa-user-plus me-2"></i>
              Add Lead
            </button>

            <Link
              to="/leads-summary"
              className="btn btn-outline-primary d-flex align-items-center px-3"
            >
              <i className="fas fa-chart-pie me-2"></i>
              Summary
            </Link>

          </div>
        </div>

        {/* Filters Section */}
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Not received">Not received</option>
              <option value="Busy">Busy</option>
              <option value="Sent demo">Sent demo</option>
              <option value="Sent proposal">Sent proposal</option>
              <option value="Wanna visit office">Wanna visit office</option>
              <option value="Wanna zoom meeting">Wanna zoom meeting</option>
              <option value="Sent proposal but no response">
                Sent proposal but no response
              </option>
              <option value="Sent demo, he will review and back to us">
                Sent demo, he will review and back to us
              </option>
              <option value="Knocked by mistake">Knocked by mistake</option>
              <option value="He has low budget">He has low budget</option>
              <option value="He will knock us when he need">
                He will knock us when he need
              </option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Priority</label>
            <select
              className="form-select"
              value={priorityFilter}
              onChange={e => setPriorityFilter(e.target.value)}
            >
              <option value="">All Priority</option>
              <option value="1">High</option>
              <option value="2">Medium</option>
              <option value="3">Low</option>
            </select>
          </div>
          <div className="col-md-2">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={dateFilter}
              onChange={e => setDateFilter(e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Follow Up Date</label>
            <input
              type="date"
              className="form-control"
              value={followUpDateFilter}
              onChange={e => setFollowUpDateFilter(e.target.value)}
            />
          </div>

          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-light"
              onClick={() => {
                setStatusFilter("")
                setPriorityFilter("")
                setDateFilter("")
                setFollowUpDateFilter("")
              }}
            >
              <i className="fas fa-times"></i>
            </button>


          </div>




        </div>

        <TableContainer
          columns={columns}
          data={filteredProjects || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search Leads..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteEvent}
          loader={deletingLead}
          onCloseClick={() => setDeleteModal(false)}
        />
        <AddLeadModal
          isOpen={addLeadModal}
          toggle={() => setAddLeadModal(!addLeadModal)}
          onLeadCreated={refetch}
        />
      </div>
    </div>
  )
}

export default AllLeads
